import { useTranslation } from "react-i18next";

import {
  GET_LIST_REQ,
  GET_LIST_RES,
} from "@sellernote/shared/src/api/dto/api-interfaces/contents-api/support";
import {
  REQUEST_GUIDE_REQ,
  REQUEST_GUIDE_RES,
} from "@sellernote/shared/src/api/dto/api-interfaces/shipda-api/support";
import {
  useAppMutation,
  useAppQueryWithQueryKeyFactory,
} from "@sellernote/shared/src/services/query";

export const SUPPORT_QUERY_KEY_GEN = {
  all: () => [{ scope: "forwarding/SUPPORT_QUERY" }] as const,

  supportBoardList: () =>
    [
      { ...SUPPORT_QUERY_KEY_GEN.all()[0], subScope: "supportBoardList" },
    ] as const,
  getSupportBoardList: (params: GET_LIST_REQ) =>
    [
      {
        ...SUPPORT_QUERY_KEY_GEN.supportBoardList()[0],
        ...params,
      },
    ] as const,
};

function useGetSupportBoardList(
  params: GET_LIST_REQ & { hidesLoading?: boolean }
) {
  const { hidesLoading, ...restParams } = params;

  const queryResult = useAppQueryWithQueryKeyFactory<
    ReturnType<typeof SUPPORT_QUERY_KEY_GEN.getSupportBoardList>,
    GET_LIST_RES
  >({
    queryKey: SUPPORT_QUERY_KEY_GEN.getSupportBoardList(params),
    requestOptions: {
      method: "get",
      path: "/article",
      apiType: "CMS_API_V2",
      params: restParams,
    },
    hidesLoading,
  });

  return { ...queryResult };
}

function useRequestGuide({
  onSuccess,
}: {
  onSuccess?: (res: REQUEST_GUIDE_RES) => void;
}) {
  const { t } = useTranslation(["queries"]);

  const mutation = useAppMutation<REQUEST_GUIDE_REQ, REQUEST_GUIDE_RES>({
    requestOptions: {
      method: "post",
      path: "/customerCare/guide",
      apiType: "SHIPDA_API",
    },

    onSuccess,

    failureModalInfo: {
      customizeMessage: () => {
        return {
          title: t(
            "queries:useRequestGuide.가이드북_신청_중_오류가_발생했습니다."
          ),
        };
      },
    },
  });

  return { ...mutation };
}

const SUPPORT_QUERY = {
  useGetSupportBoardList,
  useRequestGuide,
};

export default SUPPORT_QUERY;
